import { ReactNode } from "react";
import {
  Box,
  Flex,
  HStack,
  IconButton,
  Button,
  useDisclosure,
  useColorModeValue,
  useColorMode,
  VStack,
  Image,
  Heading,
} from "@chakra-ui/react";
import { HamburgerIcon, CloseIcon } from "@chakra-ui/icons";
import resume from "../pages/Kanhaiya-Chauhan-Resume.pdf";
import { Link, NavLink } from "react-router-dom";
import { MoonIcon, SunIcon } from "@chakra-ui/icons";
import { motion } from "framer-motion";
import AnchorLink from "react-anchor-link-smooth-scroll";
import { useState } from "react";

const Links = [
  { path: "home", title: "HOME", link: "nav-link home" },
  { path: "about", title: "ABOUT", link: "nav-link about" },
  { path: "skills", title: "SKILLS", link: "nav-link skills" },
  { path: "projects", title: "PROJECTS", link: "nav-link projects" },
  { path: "contact", title: "CONTACT", link: "nav-link contact" },
];

function Navbar() {
  const { colorMode, toggleColorMode } = useColorMode();
  const { isOpen, onOpen, onClose } = useDisclosure();

  const [navbar, setNavbar] = useState(false);

  const changeNavbar = () => {
    if (window.scrollY >= 400) {
      setNavbar(true);
    } else {
      setNavbar(false);
    }
  };

  window.addEventListener("scroll", () => {
    changeNavbar();
  });
  const openInNewTab = (url) => {
    window.open(url, "_blank", "noreferrer");
  };
  return (
    <>
      <Box
        fontFamily="Poppins"
        letterSpacing={"1.2px"}
        bg={!navbar ? "gray.800" : "white"}
        px={{ base: "3", md: "8" }}
        position="fixed"
        top="0"
        left="0"
        right="0"
        zIndex={4}
        color={!navbar ? "white" : "black"}
        shadow={!navbar ? "" : "md"}
        id={"nav-menu"}
      >
        <Flex h={16} alignItems={"center"} justifyContent={"space-between"}>
          <IconButton
            size={"md"}
            icon={isOpen ? <CloseIcon /> : <HamburgerIcon />}
            aria-label={"Open Menu"}
            display={{ md: "none" }}
            variant="ghost"
            _hover={{ bg: "none" }}
            onFocus={{ bg: "none" }}
            onClick={isOpen ? onClose : onOpen}
          />
          <HStack spacing={8} alignItems={"center"}>
            <motion.div
              initial={{
                x: -500,
                opacity: 0,
                scale: 0.5,
              }}
              animate={{
                x: 0,
                opacity: 1,
                scale: 1,
              }}
              transition={{
                duration: 1.2,
              }}
            >
              {/* <Heading letterSpacing={3} fontFamily={"sans-serif"}>
                K.C.
              </Heading> */}
              <Image
                width={"60px"}
                borderRadius={"full"}
                src={
                  !navbar
                    ? "https://static.vecteezy.com/system/resources/previews/011/423/099/original/kc-logo-k-c-design-white-kc-letter-kc-letter-logo-design-initial-letter-kc-linked-circle-uppercase-monogram-logo-vector.jpg"
                    : "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSr-ABumYSZ6SzHp4zZtUHvjM-l__5Hx36uxQ&usqp=CAU"
                }
              />
            </motion.div>
          </HStack>
          <HStack
            as={"nav"}
            spacing={20}
            display={{ base: "none", md: "flex" }}
            fontWeight="500"
            fontSize="16px"
          >
            {Links.map((elem) => (
              <AnchorLink
                href={`#${elem.path}`}
                key={elem.title}
                className={elem.link}
              >
                {elem.title}
              </AnchorLink>
            ))}
            <span className="nav-link resume">
              <button
                id="resume-button-1"
                onClick={() =>
                  openInNewTab(
                    "https://drive.google.com/file/d/19W_ve-MNUwEkv5ABa1n8YBR1Kk2fbiVj/view"
                  )
                }
              >
                <a
                  id="resume-link-1"
                  href={resume}
                  download={"Kanhaiya_Chauhan_Resume"}
                  className="nav-link resume"
                  // target={"_blank"}
                >
                  RESUME
                </a>
              </button>
            </span>
          </HStack>
          <motion.div
            initial={{
              x: 500,
              opacity: 0,
              scale: 0.5,
            }}
            animate={{
              x: 0,
              opacity: 1,
              scale: 1,
            }}
            transition={{
              duration: 1.2,
            }}
          >
            <Button
              bg="transparent"
              _hover={{ bg: "transparent" }}
              onClick={toggleColorMode}
              variant="ghost"
              color={!navbar ? "white" : "black"}
              borderRadius={"full"}
            >
              {colorMode === "light" ? <MoonIcon /> : <SunIcon />}
            </Button>
          </motion.div>
        </Flex>
        {isOpen ? (
          <VStack
            justifyContent={"center"}
            flexDirection="row"
            textAlign="center"
            alignItems="center"
            h="100vh"
            display={{ md: "none" }}
            fontWeight="500"
            fontSize="16px"
          >
            <VStack spacing={14} mt="20">
              {Links.map((elem) => (
                <AnchorLink
                  href={`#${elem.path}`}
                  key={elem.title}
                  className={elem.link}
                >
                  {elem.title}
                </AnchorLink>
              ))}

              <button
                id="resume-button-1"
                onClick={() =>
                  openInNewTab(
                    "https://drive.google.com/file/d/19W_ve-MNUwEkv5ABa1n8YBR1Kk2fbiVj/view"
                  )
                }
              >
                <a
                  href={resume}
                  download={"Kanhaiya_Chauhan_Resume"}
                  className="nav-link resume"
                  id="resume-link-1"
                >
                  RESUME
                </a>
              </button>
            </VStack>
          </VStack>
        ) : null}
      </Box>
    </>
  );
}

export default Navbar;
